export default __webpack_public_path__ + "static/media/building7.66a72d59.jpeg";